import React, { useContext, useEffect, useRef } from 'react';
import { Slider, useTheme, ThemeProvider } from '@mui/material';
import MapContext, { MapContextType } from '@/context/MapContext/MapContext';
import SwipeControlOL from './SwipeControlOL';

interface SwipeControlProps {
  swipeValue: number; // (0–1000)
  setSwipeValue: (newValue: number) => void;
}

const SwipeControl = (props: SwipeControlProps) => {
  const { map } = useContext(MapContext) as MapContextType;
  const theme = useTheme();

  const { setSwipeValue, swipeValue } = props;

  // keep reference to the control so we can remove it later
  const controlRef = useRef<SwipeControlOL | null>(null);

  const handleChange = (event: Event | React.SyntheticEvent<Element, Event>, value: number) => {
    event.preventDefault();
    event.stopPropagation();
    setSwipeValue(value);
  };

  useEffect(() => {
    if (!map) return undefined;

    if (!controlRef.current) {
      const control = new SwipeControlOL(
        (
          // another theme provider here cuz somehow the root theme context isnt working when doing it like this
          <ThemeProvider theme={theme}>
            <Slider max={1000} color="primary" size="medium" defaultValue={swipeValue} onChange={handleChange} />
          </ThemeProvider>
        )
      );

      map.addControl(control);
      controlRef.current = control;
    }

    return () => {
      if (controlRef.current) {
        map.removeControl(controlRef.current);
        controlRef.current = null;
      }
    };
  }, [map]); // depend on swipeValue too

  return null;
};

export default SwipeControl;
